/**
 * Same-origin relative redirect target used to return a user to where they
 * started after sign-in (e.g. the OAuth consent screen for MCP clients).
 */
export function sanitizeNextPath(value: string | null | undefined): string | null {
  if (!value) return null;
  // Only same-origin, relative paths. Reject protocol-relative and absolute URLs.
  if (!value.startsWith('/') || value.startsWith('//')) return null;
  if (value.includes('\\')) return null;
  return value;
}

export function getNextPathFromLocation(search: string): string | null {
  return sanitizeNextPath(new URLSearchParams(search).get('next'));
}

/** Absolute URL an auth provider should return the user to. */
export function authReturnUrl(nextPath: string | null): string {
  return nextPath ? `${window.location.origin}${nextPath}` : window.location.origin;
}
